(ns app.front.view.group.admin.fees.integration.toggle
  (:require [app.front.view.group.admin.feature-toggle :as feature-toggle]
            [app.front.view.group.admin.subs :as gas]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]))


(defn view []
  (let [tr           (<sub [:tr])
        group        (<sub [::gas/group])
        toggled?     (contains? (:group/features group) :group.feature/fee-integration)
        backend-int? (<sub [::gas/has-feature? :group.feature/backend-system-integration])
        visible?     (or backend-int?
                         (<sub [::gas/has-feature? :group.feature/public-api])
                         toggled?)]
    (when visible?
      (cc/toggle {:id         "fee-integration"
                  :on-toggle  #(>evt [::feature-toggle/toggle-group-feature
                                      (:db/id group)
                                      :group.feature/fee-integration
                                      %])
                  :label-text (str (tr [:fees/enable-integration]
                                       [(<sub [::gas/backend-system-name :fees/integration])])
                                   (when-not backend-int?
                                     (str " " (tr [:fees/enable-integration-api]))))
                  :toggled    toggled?}))))
